import type { MouseEvent, Ref } from "react";

import MobileNavCluster, {
  type MobileNavShopAction,
} from "@/blueprint/components/NavPill/MobileNavCluster";
import { cn } from "@/lib/utils";

// The floating "Shop ≡" pill the full nav collapses into on scroll, below the
// `sd` breakpoint only — from `sd` up the chrome renders FloatingNavSurface in
// its place. Presentational only — visibility/scroll behavior belongs to the
// site chrome.
type NavPillProps = {
  shopHref: string;
  shopLabel: string;
  cartCount: number;
  onCartClick: () => void;
  onMenuClick: (event: MouseEvent<HTMLButtonElement>) => void;
  menuButtonRef?: Ref<HTMLButtonElement>;
  menuExpanded?: boolean;
  // Open-sheet duties for the mobile cluster; the pill is its own header while
  // the menu is open, so the chrome retargets these instead of replacing it.
  shopAction?: MobileNavShopAction;
  shopButtonRef?: Ref<HTMLButtonElement>;
  shopHidden?: boolean;
  menuControlsId?: string;
  className?: string;
};

const NavPill = ({
  shopHref,
  shopLabel,
  cartCount,
  onCartClick,
  onMenuClick,
  menuButtonRef,
  menuExpanded = false,
  shopAction,
  shopButtonRef,
  shopHidden = false,
  menuControlsId,
  className,
}: NavPillProps) => (
  // Light-scoped so the pill's controls stay dark-on-light over dark pages;
  // the backdrop token itself is theme-aware (white on dark, see tokens.css).
  <div
    data-theme="light"
    className={cn("relative inline-flex items-center", className)}
  >
    {/* Shared with the in-flow nav row and with the open sheet's control
        row, so the sheet can land on this pill's exact coordinates. */}
    <MobileNavCluster
      variant="pill"
      shopLabel={shopLabel}
      shopAction={shopAction ?? { kind: "link", href: shopHref }}
      shopButtonRef={shopButtonRef}
      cartCount={cartCount}
      onCartClick={onCartClick}
      onMenuClick={onMenuClick}
      menuOpen={menuExpanded}
      menuButtonRef={menuButtonRef}
      menuControlsId={menuControlsId}
      shopHidden={shopHidden}
    />
  </div>
);

export default NavPill;
